import { selectFolder, selectDefaultFolder } from 'owa-mail-folder-forest-actions';
import { isFolderInFavorites } from 'owa-favorites';
import { isValidMailFolder } from 'owa-mail-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

export default function selectFolderWithFallback(routerFolderId: string) {
    // if no id is specified in the URL, select default folder
    if (!routerFolderId) {
        selectDefaultFolder();
        return;
    }

    // routerFolderId could be distinguished folderId like 'inbox', 'sentitems' which is called through router
    const folderId = folderNameToId(routerFolderId) || routerFolderId;

    // Invalid Id specified in the URL, fallback to default folder
    if (!isValidMailFolder(folderId)) {
        selectDefaultFolder();
        return;
    }

    // Valid folder in favorites
    if (isFolderInFavorites(folderId)) {
        selectFolder(folderId, 'favorites' /* treeType */);
        return;
    }

    // Valid folder not in favorites
    selectFolder(folderId, 'primaryFolderTree' /* treeType */);
}
